import { InjectionToken } from '@angular/core';
import { TenantDto } from '@nusign/picflow-backend-types';
import { Observable } from 'rxjs';

export interface PicflowAnalytics {
  track: (
    event: string,
    isImportant?: boolean,
    extraProperties?: {
      [key: string]:
        | string
        | number
        | boolean
        | { [key: string]: string | number | boolean }
        | { [key: string]: string | number | boolean }[];
    }
  ) => void;
  reportKeyboardShortcut: (name: string, location: string, extra?: { [key: string]: string | number }) => void;
  setLastButtonClicked: (ctaName: string, ctaText: string, ctaIcon: string, ctaLocation: string) => void;
  // identify(): void;
  getTrackingParams(): { [key: string]: string };
  getFirstUrl(): string;
  showIntercom(): void;
  intercomInit(): void;
  lastUrl: string;
  userTraits: { [key: string]: string | number | boolean };
  lastButtonClicked: { ctaName: string; ctaText: string; ctaIcon: string; ctaLocation: string };
  event$: Observable<{ event: string; properties: { [key: string]: unknown } }>;
  setTenant(tenant: TenantDto): void;
  tenant?: TenantDto;
  getCioContext(): {
    [key: string]: string | number | boolean;
  };
}

export const PICFLOW_ANALYTICS = new InjectionToken<PicflowAnalytics>('analytics');
